import request from "../request";
import Url from "../url/setting";

const getWeeklyPeriodPricing = ({ path = "", ...restParams } = {}) => {
  return request.get({ url: Url.getWeeklyPeriodPricing + path, ...restParams });
};
const createWeeklyPeriodPricing = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.createWeeklyPeriodPricing + path,
    ...restParams,
  });
};
const updateWeeklyPeriodPricing = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.updateWeeklyPeriodPricing + path,
    ...restParams,
  });
};
const deleteWeeklyPeriodPricing = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.deleteWeeklyPeriodPricing + path,
    ...restParams,
  });
};

const getWeeklyPeriodPricingDetail = ({ path = "", ...restParams } = {}) => {
  return request.get({
    url: Url.getWeeklyPeriodPricingDetail + path,
    ...restParams,
  });
};
const createWeeklyPeriodPricingDetail = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.createWeeklyPeriodPricingDetail + path,
    ...restParams,
  });
};
const updateWeeklyPeriodPricingDetail = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.updateWeeklyPeriodPricingDetail + path,
    ...restParams,
  });
};
const deleteWeeklyPeriodPricingDetail = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.deleteWeeklyPeriodPricingDetail + path,
    ...restParams,
  });
};

const getEnergyDemandTarget = ({ path = "", ...restParams } = {}) => {
  return request.get({ url: Url.getEnergyDemandTarget + path, ...restParams });
};
const createEnergyDemandTarget = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.createEnergyDemandTarget + path,
    ...restParams,
  });
};
const updateEnergyDemandTarget = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.updateEnergyDemandTarget + path,
    ...restParams,
  });
};
const deleteEnergyDemandTarget = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.deleteEnergyDemandTarget + path,
    ...restParams,
  });
};

const getConfig = ({ path = "", ...restParams } = {}) => {
  return request.get({
    url: Url.getConfig + path,
    ...restParams,
  });
};
const getConfigDetail = ({ path = "", ...restParams } = {}) => {
  return request.get({
    url: Url.getConfigDetail + path,
    ...restParams,
  });
};
const createConfig = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.createConfig + path,
    ...restParams,
  });
};
const updateConfig = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.updateConfig + path,
    ...restParams,
  });
};
const deleteConfig = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.deleteConfig + path,
    ...restParams,
  });
};

export default {
  getWeeklyPeriodPricing,
  createWeeklyPeriodPricing,
  updateWeeklyPeriodPricing,
  deleteWeeklyPeriodPricing,

  getWeeklyPeriodPricingDetail,
  createWeeklyPeriodPricingDetail,
  updateWeeklyPeriodPricingDetail,
  deleteWeeklyPeriodPricingDetail,

  getEnergyDemandTarget,
  createEnergyDemandTarget,
  updateEnergyDemandTarget,
  deleteEnergyDemandTarget,

  getConfig,
  getConfigDetail,
  createConfig,
  updateConfig,
  deleteConfig,
};
